/**
 * SDM sector catalog for SI dropdowns.
 * Source of truth: shared/constants/sdmSectors.js (duplicate here for CRA src scope).
 */

export const SDM_SECTOR_CATALOG = [
  { id: "ong-upstream", name: "ONG-Upstream" },
  { id: "ong-midstream", name: "ONG-Midstream" },
  { id: "ong-downstream", name: "ONG-Downstream" },
  { id: "real-estate", name: "Real Estate Dev" },
  { id: "construction", name: "Construction Materials" },
  { id: "universities", name: "Universities" },
  { id: "banks", name: "Banks" },
  { id: "insurance", name: "Insurance" },
  { id: "air-freight", name: "Air Freight" },
  { id: "rail-transport", name: "Rail Transportation" },
  { id: "marine-transport", name: "Marine Transportation" },
  { id: "road-transport", name: "Road Transportation" },
  { id: "hospitals", name: "Hospitals" },
  { id: "manufacturing", name: "Manufacturing (General)" },
  { id: "iron-steel", name: "Iron & Steel" },
  { id: "aluminium", name: "Aluminium" },
  { id: "cement", name: "Cement Manufacturing" },
  { id: "pulp-paper", name: "Pulp & Paper" },
  { id: "food-beverage", name: "Food & Beverage" },
  { id: "plastic", name: "Plastic" },
  { id: "chemical", name: "Chemical" },
  { id: "waste-processing", name: "Waste Processing Facilities" },
  { id: "wastewater", name: "Wastewater Treatment System" },
  { id: "utilities", name: "Utilities" },
  { id: "mining", name: "Mining" },
  { id: "agriculture", name: "Agriculture" },
  { id: "gov-bureaucratic", name: "Government Bodies (Bureaucratic)" },
  { id: "gov-services", name: "Government Bodies (Services/Permitting)" },
  { id: "it-ites", name: "IT & ITeS" },
  { id: "facilities-mgmt", name: "Facilities Management" },
];

export const SDM_TO_FORM_SCHEMA_SECTOR = {
  "ONG-Upstream": "Extractives & Minerals Processing",
  "ONG-Midstream": "Extractives & Minerals Processing",
  "ONG-Downstream": "Extractives & Minerals Processing",
  "Oil & Gas": "Extractives & Minerals Processing",
  Manufacturing: "Manufacturing",
  "Manufacturing (General)": "Manufacturing",
};

export function resolveFormSchemaSectorName(sectorName) {
  if (!sectorName) return null;
  const trimmed = String(sectorName).trim();
  return SDM_TO_FORM_SCHEMA_SECTOR[trimmed] || trimmed;
}

export const SDM_PRIMARY_SECTORS = [
  { id: "oil-gas", name: "Oil & Gas" },
  { id: "manufacturing", name: "Manufacturing" },
  { id: "real-estate", name: "Real Estate" },
];

const SDM_DISPLAY_ORDER = [
  ...SDM_PRIMARY_SECTORS,
  ...SDM_SECTOR_CATALOG,
];

export function orderSectorsLikeSdm(apiSectors = []) {
  const byName = new Map(
    apiSectors.map((sector) => [sector.name, sector]),
  );
  const displayNames = [
    ...new Set(SDM_DISPLAY_ORDER.map((s) => s.name)),
  ];
  const catalogNames = new Set(displayNames);

  const ordered = displayNames.map((name) => byName.get(name)).filter(Boolean);
  const extras = apiSectors
    .filter((sector) => !catalogNames.has(sector.name))
    .sort((a, b) => a.name.localeCompare(b.name));

  return [...ordered, ...extras];
}
